module.exports = __webpack_public_path__ + "img/tls.3c1ccf11.svg";